import type { ForwardingOrder } from '../types'

const labels:Record<string,string>={
  draft:'Preparing quote',rating:'Preparing quote',quoted:'Choose shipping',awaiting_payment:'Payment required',
  paid:'Awaiting package',label_pending:'Preparing shipment',label_ready:'Pending shipment',
  warehouse_review:'At warehouse',customs_action_required:'Customs review required',
  in_transit:'In transit',delivered:'Delivered',exception:'Under review',cancelled:'Cancelled',
}

function statusValue(order:ForwardingOrder){
  if(order.customsRecertificationRequired)return'customs_action_required'
  if(order.status==='paid'&&order.receivedAt)return'warehouse_review'
  return order.status
}

export function CustomerStatus({order}:{order:ForwardingOrder}) {
  const value=statusValue(order)
  const label=labels[value]||value.replaceAll('_',' ')
  const good=['in_transit','delivered'].includes(value)
  const warn=['draft','rating','quoted','awaiting_payment','paid','warehouse_review','customs_action_required','label_pending','label_ready'].includes(value)
  const danger=value==='exception'
  return <span className={`status ${danger?'status--danger':good?'status--good':warn?'status--warn':'status--plain'}`}><i/>{label}</span>
}
